import { CellClickedEvent, ColDef } from "ag-grid-community";
import { ConditionRowData } from "./table-data";
import type { FhirSectionProps } from "../fhir-section";
import FhirSection from "../fhir-section";

function ConditionsSection(props: FhirSectionProps) {
  const defaultColDef: ColDef = {
    flex: 1,
    onCellClicked: (event: CellClickedEvent) => props.handleCellClick(props.sectionId, event),
    cellStyle: props.handleCellStyle,
  };

  const chronicOnlyFilter = {
    label: "Chronic only",
    filterFn: (rowData: ConditionRowData) => rowData.isChronic,
  };

  return <FhirSection {...props} defaultColDef={defaultColDef} filterToggle={chronicOnlyFilter} />;
}

export default ConditionsSection;
